module.exports = __webpack_public_path__ + "img/5-3.7b0a840d.svg";